import { normalizeCnpj } from "../cnpj/cnpj.helpers";
import { isValidCnpj } from "../cnpj/cnpj.rules";

import { cleanCpf } from "../cpf/cpf.helpers";
import { isValidCpf } from "../cpf/cpf.rules";

export interface ValidationResult {
  valid: boolean;
  message: string;
}

export const validateFiscalDocument = (
  value: string,
  allow = false
): ValidationResult => {
  if (!value) {
    return { valid: false, message: "Informe um CNPJ ou CPF" };
  }

  const cleaned = value.replace(/[^a-zA-Z0-9]/g, "").toUpperCase();

  if (cleaned.length < 11) {
    return { valid: false, message: "CNPJ ou CPF incompleto" };
  }

  if (cleaned.length === 11) {
    if (!/^\d+$/.test(cleaned)) {
      return { valid: false, message: "CPF deve conter apenas números" };
    }

    const cpf = cleanCpf(cleaned);

    if (/^(\d)\1+$/.test(cpf)) {
      return {
        valid: false,
        message: "CPF com todos os dígitos iguais não é válido",
      };
    }

    if (!isValidCpf(cpf)) {
      return {
        valid: false,
        message: "CPF inválido — dígitos verificadores incorretos",
      };
    }

    return { valid: true, message: "" };
  }

  if (cleaned.length > 11 && cleaned.length < 14) {
    return {
      valid: false,
      message: "CNPJ incompleto — são necessários 14 caracteres",
    };
  }

  if (cleaned.length === 14) {
    const cnpj = normalizeCnpj(cleaned, allow);

    if (/^(\w)\1+$/.test(cnpj)) {
      return {
        valid: false,
        message: "CNPJ com todos os caracteres iguais não é válido",
      };
    }

    if (!allow && /[A-Z]/.test(cnpj)) {
      return {
        valid: false,
        message: "CNPJ alfanumérico não está habilitado",
      };
    }

    if (!isValidCnpj(cnpj)) {
      return {
        valid: false,
        message: "CNPJ inválido — dígitos verificadores incorretos",
      };
    }

    return { valid: true, message: "" };
  }

  return { valid: false, message: "Documento inválido" };
};
